import React from 'react';
import { buildXmlDiv } from "./XmlHelper.mjs";
import { XmlContainer } from "./XmlSyntaxHighlighter.styled.mjs";
export var XmlSyntaxHighlighter = function XmlSyntaxHighlighter(_ref) {
  var xml = _ref.xml;
  return /*#__PURE__*/React.createElement(XmlContainer, {
    "data-testid": "delivery-info-dialog-xml-content"
  }, /*#__PURE__*/React.createElement("pre", {
    dangerouslySetInnerHTML: {
      __html: buildXmlDiv(xml)
    }
  }));
};